import React, { useRef } from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import react from "../Assets/react.svg";
import javascript from "../Assets/javascript-1.svg";
import typescript from "../Assets/typescript.png";
import node from "../Assets/nodejs.svg";
import aws from "../Assets/amazon.svg";
import kubernetes from "../Assets/kuberanets.svg";
import docker from "../Assets/docker.svg";
import quilsys from "../Assets/Quilsys.png";
import { JenkinsSvg } from "../Assets";
import grafana from "../Assets/grafana.png";
import prometheus from "../Assets/Prometheus.png";
import loki from "../Assets/logo-grafana-loki.png";
import rapid7 from "../Assets/rapid7.png";
import dotnet from "../Assets/asp-net-logo.png";
import mongodb from "../Assets/mongoDB.png";
import csharp from "../Assets/csharp.png";
import { BiSolidLeftArrow, BiSolidRightArrow } from "react-icons/bi";
import sonarqube from "../Assets/sonarqube.png";
import fellowship from "../Assets/fellowship.png";
import nessus from "../Assets/nessus.png";
const Technology = () => {
  const sliderRef = useRef(null);
  const svgArray = [
    {
      id: 1,
      svgName: "React Js",
      content: <img src={react} alt="React Js" />,
    },
    {
      id: 2,
      svgName: "Java Script",
      content: (
        <img
          src={javascript}
          alt="Java Script"
          style={{ height: "100px", width: "80px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 3,
      svgName: "Type Script",
      content: (
        <img
          src={typescript}
          alt="Type Script"
          style={{
            height: "80px",
            width: "80px",
            textAlign: "center",
            padding: "10px",
          }}
        />
      ),
    },
    {
      id: 4,
      svgName: "Node Js",
      content: <img src={node} alt="Node JS" />,
    },
    {
      id: 5,
      svgName: "Amazon Web Service",
      content: <img src={aws} alt="Amazon Web Service" />,
    },
    {
      id: 6,
      svgName: "Kuberanets",
      content: <img src={kubernetes} alt="Kuberanets" />,
    },
    {
      id: 7,
      svgName: "Docker",
      content: <img src={docker} alt="Docker" />,
    },
    {
      id: 8,
      svgName: "Qualys",
      content: (
        <img
          src={quilsys}
          alt="Quilsys"
          style={{ height: "100px", width: "80px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 7,
      svgName: "Jenkins",
      content: (
        <img
          src={JenkinsSvg}
          alt="Jenkins"
          style={{ height: "100px", width: "100px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 8,
      svgName: "Grafana",
      content: (
        <img
          src={grafana}
          alt="Grafana"
          style={{ height: "100px", width: "100px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 9,
      svgName: "Prometheus",
      content: (
        <img
          src={prometheus}
          alt="Prometheus"
          style={{ height: "100px", width: "100px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 10,
      svgName: "LOKI",
      content: (
        <img
          src={loki}
          alt="LOKI"
          style={{ height: "100px", width: "100px", textAlign: "center" }}
        />
      ),
    },
    {
      id: 11,
      svgName: "Rapid7",
      content: (
        <img
          src={rapid7}
          alt="Rapid7"
          style={{
            height: "25px",
            width: "100px",
            paddingTop: "45px",
            paddingBottom: "30px",
          }}
        />
      ),
    },
    {
      id: 12,
      svgName: "ASP.Net",
      content: (
        <img
          src={dotnet}
          alt="ASP.Net"
          style={{
            height: "70px",
            width: "100px",
            paddingTop: "13px",
            paddingBottom: "15px",
          }}
        />
      ),
    },
    {
      id: 13,
      svgName: "MongoDB",
      content: (
        <img
          src={mongodb}
          alt="MongoDB"
          style={{
            height: "100px",
            width: "60px",
          }}
        />
      ),
    },
    {
      id: 14,
      svgName: "C#",
      content: (
        <img
          src={csharp}
          alt="C#"
          style={{
            height: "100px",
            width: "100px",
          }}
        />
      ),
    },
    {
  id: 15,
  svgName: "SonarQube",
  content: (
    <img
      src={sonarqube}
      alt="SonarQube"
      style={{ height: "90px", width: "100px" }}
    />
  ),
},
{
  id: 16,
  svgName: "Zap",
  content: (
    <img
      src={fellowship}
      alt="Fellowship"
      style={{ height: "90px", width: "100px" }}
    />
  ),
},
{
  id: 17,
  svgName: "Nessus",
  content: (
    <img
      src={nessus}
      alt="Nessus"
      style={{ height: "90px", width: "100px" }}
    />
  ),
},
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 2500,
    slidesToShow: 7,
    slidesToScroll: 6,
    autoplay: true,
    // autoplaySpeed: 0,
    cssEase: "ease-in-out",
    // centerMode: true,
    // centerPadding: "50px",

    responsive: [
      { breakpoint: 1150, settings: { slidesToShow: 5, slidesToScroll: 5 } },
      { breakpoint: 840, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 680, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
   
      <div id="technologies">
        <h1>Technologies</h1>
        <div className="slider-container container-fluid">
          {/* <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(to right, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0) 75%, rgba(255, 255, 255, 0.9))",
              zIndex: 1,
            }}
          ></div>{" "} */}
          <div className="row">
            <div
              style={{
                zIndex: 1,
              }}
              className="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-center align-items-center hide-on-small"
            >
              <BiSolidLeftArrow
                onClick={() => sliderRef.current.slickPrev()}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className="col-lg-10  col-md-10 col-sm-10">
              <Slider ref={sliderRef} {...settings}>
                {svgArray.map((item) => (
                  <div key={item.id}>
                    <div className="single-solutions-box text">
                      <div className="tech-icon">{item.content}</div>
                      <div className="tech-label">{item.svgName}</div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            <div
              style={{
                zIndex: 1,
              }}
              className="col-lg-1  col-md-1 col-sm-1 d-flex justify-content-center align-items-center hide-on-small"
            >
              <BiSolidRightArrow
                onClick={() => sliderRef.current.slickNext()}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </div>
  
  );
};

export default Technology;
